
import React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import "./carousel.scss"

const MiniCarouselCSS = ({ slides = [] }) => {

  if (!slides.length) return null

  return (
    <div className="carousel js-carousel">

      {/* Radios dynamiques */}
      {slides.map((_, i) => (
        <input
          key={`radio-${i}`}
          type="radio"
          name="carousel"
          id={`c${i}`}
          defaultChecked={i === 0}
        />
      ))}

      {/* Slides */}
      <div
        className="slides"
        style={{ width: `100%` }}
      >
        {slides.map((s, i) => (
          <div className="slide" key={i}>
            {s.image?.localImage?.childImageSharp ? (
              <GatsbyImage
                image={getImage(s.image.localImage.childImageSharp)}
                alt={s.image.alt || ""}
                className="carousel-image"
              />
            ) : s.image?.url ? (
              <img src={s.image.url} alt={s.image.alt || ""} className="carousel-image" loading="lazy"/>
            ) : null}
          </div>
        ))}
      </div>
      
      {/* Dots */}
      <div className="dots">
        {slides.map((_, i) => (
          <label key={`dot-${i}`} htmlFor={`c${i}`} />
        ))}
      </div>
    </div>
  )
}

export default MiniCarouselCSS
